import axios from "../plugins/parseAxios";

export class LogActiveUserAPI {
  static createLogActiveUser(marketId) {
    return axios.post("functions/createLogActiveUser", {
      marketId
    });
  }
}